import $ from "jquery";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LocomotiveScroll from "locomotive-scroll";
import className from "./className";
import constructPreloader from "./components/Preloader";
import constructCNNBar from "./components/CNNBar";
import constructHero from "./components/Hero";
import constructQuote from "./components/quote";
import constructCounter from "./components/Counter";
import constructMidCalltoAction from "./components/MidCalltoAction";
import constructLotties from "./components/Lotties";
import constructSectionCopy from "./components/SectionCopy";
import constructAnudip from "./components/sequence/Anudip";
import constructAzad from "./components/sequence/Azad";
import constructWeACT from "./components/sequence/WeACT";
import constructHub from "./components/hub";
import utils from './utils';
import snap from "./components/snap";
import analytics from "./analytics";

const { isMobile, getOffset, getZeroToOne, triggerEventOnce, isTouchDevice } = utils;
var ev = function ( eventName, data, target ) {
    var target = target ? target : document;
    var e = new CustomEvent( eventName, { detail: data } );
    target.dispatchEvent( e );
};

window.ev = ev;

$( document ).ready( function() {
    gsap.registerPlugin( ScrollTrigger );
    gsap.registerPlugin( className );

    $( '[data-mob-noscorll]' ).removeAttr( 'data-scroll' );

    const isHubPage = document.getElementById('hub-page') ? true : false;

    var lscroll = new LocomotiveScroll( {
        el: document.querySelector( "[data-scroll-container]" ),
        scrollFromAnywhere: true,
        smooth: true,
        smartphone: {
            smooth: !isHubPage,
            direction: "vertical",
        },
        tablet: {
            smooth: !isHubPage,
            direction: "vertical",
        },
        lerp: 0.1,
        multiplier: isMobile ? 1 : 0.4,
        getDirection: true,
    } );

    ScrollTrigger.scrollerProxy( "[data-scroll-container]", {
        scrollTop(value) {
          return arguments.length
            ? lscroll.scrollTo(value, 0, 0)
            : lscroll.scroll.instance.scroll.y;
        }, // we don't have to define a scrollLeft because we're only scrolling vertically.
        getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
          };
        },
        // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
        pinType: document.querySelector( "[data-scroll-container]" ).style.transform ? "transform" : "fixed"
    } );

    window.lscroll = lscroll;

    window.addEventListener( "resize", function ( event ) {
        ScrollTrigger.refresh();
    }, true );

	const winHeight = $( window ).height();
	var $ctaSection = $( '.footer-top' );
    lscroll.on( "scroll", function ( args ) {
        ScrollTrigger.update();

        ev( "ScrollEvent", { args });

        var instance = lscroll.scroll.instance;

        var p = instance.scroll.y / instance.limit.y;
        if (p > 0.25) {
            triggerEventOnce( '2022-accenture-progress-25' );
        }
        if (p > 0.50) {
            triggerEventOnce( '2022-accenture-progress-50' );
        }
        if (p > 0.75) {
            triggerEventOnce( '2022-accenture-progress-75' );
        }
        if (p > 0.98) {
            triggerEventOnce( '2022-accenture-progress-100' );
        }

        // Footer top background scaling
		var ctaTop = getOffset( $ctaSection.offset().top );
		if( ctaTop < winHeight ) {
			$( '.footer-top-bg .bg-holder' ).css( 'transform', 'scale(' + (1+(1-getZeroToOne(ctaTop/winHeight))*0.15) +')' );
		}
    } );
    
    lscroll.on( "call", function ( value, way, obj ) {
        ev( "CallEvent", { value, way, obj, direction: lscroll.scroll.instance.direction }, obj.el );
    } );

    setTimeout( function () {
        lscroll.update();
    }, 1000 );

    constructPreloader();
    constructHero();

    constructCNNBar();
    constructLotties();

    constructAnudip();
    constructAzad();

    constructHub();

    document.addEventListener( "preloaderDone", () => {
        constructQuote();
        constructCounter();
        constructMidCalltoAction();
        constructSectionCopy();

        constructWeACT();

        $( '.btn-toggle' ).click( function() {
            $( '.main-menu' ).toggleClass( 'is-active' );
        } );
    }, { once: false } );

    snap();
    analytics();
} );
